import React, { useState, useEffect } from 'react'
import Modal from 'react-responsive-modal'
import { ValidatorForm } from 'react-form-validator-core'

import toastr from '@modules/toastr'
import SelectField from '@shared/form-fields/select'
import findSelected from '@helpers/find-selected'
import { fullName } from '@modules/form-wizard/utils'

// Statuses that an officer is allowed to override to
const STATUS_OPTIONS = [
  { label: 'Ready For Pickup', value: 'ready for pickup' },
  { label: 'Not Present', value: 'not present' },
]

export default function StatusOverride ({ open, onClose: close, item }) {
  const [status, setStatus] = useState('')
  const [saving, setSaving] = useState(false)

  const { service_name, delivery_status } = item ?? {}
  const user = item?.user

  // Reset the selected status whenever a different item is opened
  useEffect(() => {
    setStatus('')
    setSaving(false)
  }, [item])

  const onClose = () => {
    setStatus('')
    setSaving(false)
    close()
  }

  const overrideStatus = async () => {
    if (!status) return
    const { service_type, id: service_id } = item

    setSaving(true)

    try {
      await $app.axios.patch('/deliveries/override_status_update', {
        service_type,
        service_id,
        status,
      })

      toastr.success('Success', 'Delivery status updated')
      Object.assign(item, {
        delivery_status: status,
        collectable: status == 'ready for pickup',
      })
    } catch (err) {
      console.error(err)
      toastr.error('Error', 'Unable to update delivery status')
      setSaving(false)
      return
    }

    onClose()
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      classNames={{ modal: 'w-full sm:w-128' }}
      center
    >
      <div className='modal-header'>
        <h5 className='modal-title'>{fullName(user)}</h5>
      </div>
      <ValidatorForm onSubmit={overrideStatus}>
        <div className='modal-body'>
          <div className='mb-6'>
            <strong className='d-block'>Service</strong>
            <span>{service_name}</span>
          </div>
          <div className='mb-6'>
            <strong className='d-block'>Current Status</strong>
            <span>
              {delivery_status == 'pending'
                ? 'In Transit'
                : delivery_status?.capitalize()}
            </span>
          </div>
          <div className='form-group form-show-validation'>
            <label htmlFor='status'>
              Change Status To<span className='required-label'>*</span>
            </label>
            <SelectField
              name='status'
              value={status}
              values={findSelected(STATUS_OPTIONS, status)}
              options={STATUS_OPTIONS}
              onChange={val => setStatus(val?.[0]?.value ?? '')}
              className='form-control'
              validators={['required']}
              errorMessages={['Required']}
            />
          </div>
        </div>
        <div className='modal-footer'>
          <button
            type='button'
            className='btn btn-round mr-2'
            onClick={onClose}
          >
            Close
          </button>
          <input
            type='submit'
            value={saving ? 'Saving...' : 'Update Status'}
            className='btn custom-btn btn-round'
            disabled={!status || saving}
          />
        </div>
      </ValidatorForm>
    </Modal>
  )
}
